/**
 * @generated SignedSource<<3097fa5934635884fb2f43c3e7c22404>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SignalDetailImages_signal$data = {
  readonly descriptionImages: ReadonlyArray<{
    readonly id: string;
    readonly size: {
      readonly url: string;
    } | null;
  }>;
  readonly " $fragmentType": "SignalDetailImages_signal";
};
export type SignalDetailImages_signal$key = {
  readonly " $data"?: SignalDetailImages_signal$data;
  readonly " $fragmentSpreads": FragmentRefs<"SignalDetailImages_signal">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SignalDetailImages_signal",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Image",
      "kind": "LinkedField",
      "name": "descriptionImages",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "minHeight",
              "value": 699
            },
            {
              "kind": "Literal",
              "name": "minWidth",
              "value": 699
            }
          ],
          "concreteType": "ImageSize",
          "kind": "LinkedField",
          "name": "size",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "url",
              "storageKey": null
            }
          ],
          "storageKey": "size(minHeight:699,minWidth:699)"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Signal",
  "abstractKey": null
};

(node as any).hash = "7f85a7942bfd8696d42da4a9b62b4806";

export default node;
